<template>
	<ui-doc-preview docName="Pré-visualizar documento" name="contracts-model-preview" :url="url" />
</template>

<script>
	import { uiDocPreview } from '@/components/ui'

	export default {
		components: {
			uiDocPreview,
		},

		data() {
			return {
				url: '',
			}
		},

		methods: {
			close() {
				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			initParams() {
				this.url = this.$route.params.url.replace(/__bar/g, '/')
			},
		},

		mounted() {
			this.$root.$on('modal-open-contracts-model-preview', () => {
				this.openIframe('closed-modal')
				this.initParams()
			})

			this.$root.$on('modal-close-contracts-model-preview', () => {
				this.close()
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-contracts-model-preview')
			this.$root.$off('modal-close-contracts-model-preview')
		},
	}
</script>

<style></style>
